import { createWrapperHOC } from 'utils/hoc';
import Toggleable from './Toggleable';

export default function createToggleable(ToggleableComponent) {
    return createWrapperHOC(Toggleable, ToggleableComponent);
}
